// Copyright (c) 2017 Deere & Company

import {getClaimAction, getClaimDefaultState, mergeClaimTypes} from '../../shared/services/claim-shared-helper';
import {getClaimRoutes} from '../../../shared/components/create-claim-modal/get-claim-routes-service';
import {routerActions} from 'react-router-redux';

export const onEditClaim = (key, pin, claimType, claim) =>

    dispatch => {

        if (key === claimType) {

            dispatch({
                isVisible: false,
                type: `UPDATE_CLAIM_${getClaimAction(key)}_CREATE_CLAIM_MODAL_VISIBILITY`
            });

            document.body.classList.remove('warranty-modal-is-open');

            return;

        }

        document.body.classList.remove('warranty-modal-is-open');
        dispatch(routerActions.push(getClaimRoutes(key, pin)));

        dispatch({
            type: `SET_CLAIM_${getClaimAction(key)}`,
            updatedClaim: mergeClaimTypes(claim, getClaimDefaultState(key))
        });

        dispatch({
            isCopied: true,
            type: `UPDATE_CLAIM_${getClaimAction(key)}_IS_COPIED`
        });

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/edit-claim.js